// extracted by mini-css-extract-plugin
module.exports = {"input-comment":"style_input-comment__2K7kY","button-comment-wrapper":"style_button-comment-wrapper___g6JD"};